import { IconButton, Typography } from '@mui/material';
import MaterialReactTable from 'material-react-table';
import React, { useEffect, useMemo, useState } from 'react'
import { getData } from '../../../../../../services/library';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import CloseIcon from '@mui/icons-material/Close';

function HistorialPrecioEspecial(props) {
      const [historial, setHistorial] = useState();
    
      const obtenerHistorial = () => {
        getData("/envasado_historial_especial/historialcliente/"+props.cliente.id, setHistorial);
      };
    
      useEffect(() => {
        obtenerHistorial();
      }, []);
    
    const columns = useMemo(
      () => [
        { 
          header: "Producto", 
          accessorKey: "nombre_producto", 
          size: 150 
        },
    
        // {
        //   header: "Mínimo",
        //   columns: [
            {
              header: "Anterior",
              accessorKey: "precio_minimo_anterior",
              size: 100,
            },
            {
              header: "Nuevo",
              accessorKey: "precio_minimo_nuevo",
              size: 100,
            },
        //   ],
        // },
        // {
        //   header: "Máximo",
        //   columns: [
        //     {
        //       header: "Anterior",
        //       accessorKey: "precio_maximo_anterior",
        //       size: 100,
        //     },
        //     {
        //       header: "Nuevo",
        //       accessorKey: "precio_maximo_nuevo",
        //       size: 100,
        //     },
        //   ],
        // },
    
        { 
          header: "Actualización", 
          accessorKey: "fecha", 
          size: 120 
        },
      ],
      []
    );
    
    
      const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "success",
        size: "small",
      };
    
      const customLocalization = {
        ...MRT_Localization_ES,
        expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
        expand: "Ex", 
      };
    
      const initialState = {
        density: "compact",
        pagination: { pageIndex: 0, pageSize: 5 },
        grouping: ["nombre_producto"],
      };
    
      const tableHeadCellProps = {
        align: "left",
        sx: {
          fontSize: 16,
          color: "white",
          fontWeight: "normal",
          backgroundColor: "#2471A3",
          borderColor: "black",
        },
      };

  return (
        <>
      {/* <Container maxWidth="xl" sx={{ my: 1 }} disableGutters> */}
        <MaterialReactTable
          columns={columns}
          data={historial ?? [{}]}
          layoutMode={"grid"}
          initialState={initialState}
          enableColumnActions={false} //deshabilita las acciones POR COLUMN}
          enableGlobalFilterModes={false}
          enableHiding={false}
          enableGrouping={true}
          enablePinning={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn={"last"}
          enableExpandAll={false}
          localization={customLocalization}
          enableToolbarInternalActions={true}
          muiTableHeadCellProps={tableHeadCellProps}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          enableDensityToggle={false}
          positionToolbarAlertBanner="none"
          muiTableDetailPanelProps={{
            sx: {
              backgroundColor: "white", // Fondo blanco para el panel de detalles
              width: "100%",
            },
          }}
          enableColumnResizing={true}
          muiTableBodyCellProps={({ row }) => ({
            align: "left",
          })}
          renderTopToolbarCustomActions={() => (
            <>
            <IconButton
            edge="start"
            color="inherit"
            onClick={() => props.onClose()}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
              <Typography variant="poster" fontSize={26}>
                Historial   
              </Typography>
            </>
          )}
        />
      {/* </Container> */}
    </>
  )
}

export default HistorialPrecioEspecial